import script from "./Marketing.vue?vue&type=script&setup=true&lang=js"
export * from "./Marketing.vue?vue&type=script&setup=true&lang=js"

import "./Marketing.vue?vue&type=style&index=0&id=52650c4c&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52650c4c"]])

export default __exports__